<template>
  <b-modal
    no-close-on-backdrop
    id="upload-modal"
    :ok-title="$t('save')"
    ok-variant="success"
    :cancel-title="$t('cancel')"
    cancel-variant="danger"
    centered
    :title="$t('add')"
    size="lg"
    :ok-disabled="loading"
    @ok="onSubmit"
    @show="showModal"
  >
    <div style="border: #b9b9c3 2px dashed" class="mb-2 p-50">
      <b-row>
        <b-col md="12">
          <b-row>
            <b-col
              md="3"
              class="mb-1"
              v-for="(file, index) in files"
              :key="index"
            >
              <div
                class="img-box border d-flex flex-column justify-content-between"
              >
                <b-avatar
                  style="width: 100%; min-height: 100px"
                  v-if="file.type == 'application/pdf'"
                  src="https://avatars.mds.yandex.net/i?id=92091a126a7e7aed961e2dbe7521afa6-4819109-images-thumbs&n=13"
                />
                <b-avatar
                  square
                  style="width: 100%; min-height: 100px"
                  v-else
                  :src="file.src"
                />

                <div>
                  <div>
                    <div class="d-flex justify-content-between">
                      <span
                        style="
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                      "
                        >{{ file.name }}</span
                      >
                      <div>
                        <feather-icon
                          icon="XIcon"
                          class="ml-50 trash-icon"
                          size="18"
                          @click="removeItem(index)"
                        />
                      </div>
                    </div>
                    <b-progress
                      :value="file.progress"
                      max="100"
                      show-value
                      variant="secondary"
                      class="progress-bar-secondary"
                    />
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <div
        @drop.prevent="onDropHandler"
        @dragstart="dragHandler"
        @dragleave.prevent="dragLeaveHandler"
        @dragover="dragHandler"
      >
        <label for="file22" class="d-flex justify-content-center p-3">
          <feather-icon class="mr-50" icon="PaperclipIcon" size="16" />
          {{$t('general.select')}}
        </label>
        <input
          id="file22"
          type="file"
          multiple
          class="d-none"
          @change="changeHandler"
        />
      </div>
    </div>
    <validation-observer ref="infoLid">
      <b-form-group label="Название продукта">
        <!-- <validation-provider
            #default="{ errors }"
            name="product"
            rules="required"
          >

            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider> -->
        <validation-provider
          #default="{ errors }"
          name="product"
          rules="required"
        >
          <b-form-textarea
            v-model="description"
            placeholder="Написать комментарии..."
          >
          </b-form-textarea>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </validation-observer>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import {
  BFormGroup,
  BModal,
  BFormFile,
  BFormTextarea,
  BRow,
  BCol,
  BProgress,
  BAvatar,
} from "bootstrap-vue";

import { getUserData } from '@/auth/utils';

export default {
  props: {
    object_id: {
      type: Number
    }
  },
  data() {
    return {
      required,
      loading: false,
      drag: false,
      description: "",
      files: [],
      filesData: [],
    };
  },
  methods: {
    ...mapActions("comments", ["ADD_COMMENT"]),
    showModal() {
      this.files = []
      this.filesData = []
      this.description = ''
    },
    async onSubmit(bvModalEvt) {
      bvModalEvt.preventDefault();

      this.$refs.infoLid.validate().then(async (success) => {
        if (!success) {
          return;
        }

        try {
          this.loading = true;

          const formData = new FormData();
          formData.append("message", this.description);
          formData.append("content_type", 39);
          formData.append("object_id", this.object_id);
          formData.append("author", getUserData()?.id);

          for (let i = 0; i < this.filesData.length; i++) {
            formData.append("files", this.filesData[i]);
          }

          await this.ADD_COMMENT(formData);


          this.$nextTick(() => {
            this.$bvModal.hide("upload-modal");
          });

          this.loading = false;

          this.$emit("refresh");

          this.$_okToast();
        } catch (err) {
          console.log(err)
          this.loading = false;
          this.$_errToast('Error');
        }
      });
    },
    changeHandler(event) {
      if (!event.target.files?.length) {
        return;
      }
      const files = [...event.target.files];
      files.forEach((file) => {
        this.fileReader(file);
      });
    },
    fileReader(file) {
      if (!file) {
        return;
      }
      const reader = new FileReader();

      reader.onload = (ev) => {
        const src = ev.target.result;

        this.files.push({
          src,
          name: file.name,
          type: file.type,
          progress: 0,
        });

        this.filesData.push(file);
      };

      reader.readAsDataURL(file);
    },
    removeItem(index) {
      this.files.splice(index, 1);
      this.filesData.splice(index, 1);
    },

    onDropHandler(event) {
      event.preventDefault();

      this.drag = false;

      const files = [...event.dataTransfer.files];

      files.forEach((file) => {
        // const type = this.filePermissionType.includes(file.type);
        // if (!type) {
        //   return this.$_errToast(`Неверный тип файла ${file.type}`);
        // }
        this.fileReader(file);
      });
    },
    dragHandler(event) {
      event.preventDefault();
      this.drag = true;
    },
    dragLeaveHandler() {
      this.drag = false;
    },
  },

  components: {
    ValidationProvider,
    ValidationObserver,
    BModal,
    BFormGroup,
    BFormFile,
    BFormTextarea,
    BProgress,
    BAvatar,
    BRow,
    BCol,
  },
};
</script>

<style scoped>
.trash-icon {
  color: red;
  cursor: pointer;
}
</style>
